import { healthContract } from "./health.contract";
import { testCustomerMatchContract } from "./test.contract";
import { memoryBankContracts } from "./memory-bank.contract";
import { orgConfigModulesContract } from "./org-config/modules/module-configs.contract";
import { accountsReceivableContracts } from "./accounts-receivable";
import { communicationsContracts } from "./communications";
import { integrationsContracts } from "./integrations";
import { workflowContracts } from "./workflows.contract";
import { featureFlagsContracts } from "./testing";
import { accountsPayableContracts } from "./accounts-payable";
import { entityAssociationsContracts } from "./core/entity-associations.contract";
import { activityLogContracts } from "./core/activity-log.contract";
import { authzContracts } from "./authz.contract";
import { customViewsContracts } from "./core/custom-views.contract";
import {
  transactionsContracts,
  paymentsContracts,
  chargesContracts,
} from "./finance";
import { rebatesContracts } from "./rebates";
import { supplyChainContracts } from "./supply-chain";
import { supplyChainManagementContracts } from "./supply-chain-management";
import { shipAndDebitContracts } from "./ship-and-debit";
import {
  aiSuggestionContracts,
  foregroundAgentContracts,
  threadsContracts,
  streamingAudioContracts,
} from "./ai";
import { demoContracts } from "./demo";
import { portalContracts } from "./portal";
import { homeContracts } from "./home";

/**
 * Main contract router that defines all available RPC procedures
 */
export const contractRouter = {
  // Health check endpoints
  health: {
    check: healthContract,
  },
  // Test endpoints
  test: {
    customerMatch: testCustomerMatchContract,
  },
  // Testing utilities
  testing: {
    featureFlags: featureFlagsContracts,
  },
  // Authorization endpoints
  authz: authzContracts,
  // Memory bank note endpoints
  memoryBank: memoryBankContracts,
  // Organization configuration endpoints
  org: {
    config: {
      modules: orgConfigModulesContract,
    },
  },
  // Core system endpoints
  core: {
    entityAssociations: entityAssociationsContracts,
    customViews: customViewsContracts,
    activityLog: activityLogContracts,
  },
  // Integrations / plugins endpoints
  integrations: integrationsContracts,
  // Accounts receivable endpoints
  accountsReceivable: accountsReceivableContracts,
  // Workflow endpoints
  workflows: workflowContracts,
  // Communications endpoints
  communications: communicationsContracts,
  // Accounts payable endpoints
  accountsPayable: accountsPayableContracts,
  // Finance endpoints
  finance: {
    payments: paymentsContracts,
    transactions: transactionsContracts,
    charges: chargesContracts,
  },
  // Rebates endpoints
  rebates: rebatesContracts,
  // Supply chain endpoints
  supplyChain: supplyChainContracts,
  // Supply chain management endpoints (kebab-case REST paths)
  supplyChainManagement: supplyChainManagementContracts,
  // Ship and Debit endpoints
  shipAndDebit: shipAndDebitContracts,
  // AI endpoints
  ai: {
    suggestions: aiSuggestionContracts,
    foregroundAgent: foregroundAgentContracts,
    threads: threadsContracts,
    streamingAudio: streamingAudioContracts,
  },
  // Demo endpoints
  demo: demoContracts,

  // Customer portals endpoints
  portal: portalContracts,

  // Home page endpoints
  home: homeContracts,
} as const;

// Re-export types from authz contracts
export * from "./authz.contract";
// Re-export types from memory bank contracts
export * from "./memory-bank.contract";
// Re-export types from accounts receivable contracts
export * from "./accounts-receivable/sales-orders.contract";
export * from "./accounts-receivable/sales-order-drafts.contract";
export * from "./accounts-receivable/customer-products.contract";
export * from "./accounts-receivable/discounts.contract";
export * from "./accounts-receivable/sales-orders-rpc.contract";
// Re-export types from communications contracts
export * from "./communications";
// Re-export types from integrations contracts
export * from "./integrations";
// Re-export types from workflows contracts
export * from "./workflows.contract";
// Re-export types from testing contracts
export * from "./testing";
// Re-export types from accounts payable contracts
export * from "./accounts-payable";
// Re-export types from finance contracts
export * from "./finance";
// Re-export types from core contracts
export * from "./core/entity-associations.contract";
export * from "./core/custom-views.contract";
export * from "./core/activity-log.contract";
// Re-export types from rebates contracts
export * from "./rebates";
// Re-export types from supply chain contracts
export * from "./supply-chain";
// Re-export types from supply chain management contracts
export * from "./supply-chain-management";
// Re-export types from ship and debit contracts
export * from "./ship-and-debit";
// Re-export types from AI contracts
export * from "./ai";
// Re-export types from demo contracts
export * from "./demo";

// Re-export portal schemas + types
export * from "./portal";
// Re-export home schemas + types
export * from "./home";
